import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route,Outlet } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import './App.scss';
import '../src/styles/MedioPunto.scss';
import './styles/Table.scss';
import './styles/MedioPunto.scss';
import './styles/Forms.scss';
import { AuthProvider } from './components/AuthManagement/AuthContext';
import { PrivateRoute, PublicRoute } from './components/AuthManagement/RouteTypes';
import { AdminRoute } from './components/AuthManagement/AdminRoute';
import LoadingSpinner from '../src/components/common/LoadingSpinner';
import Base from './views/Base/Base';
import AdminPortal from './views/Admin/AdminPortal';
import { loadContext } from './components/common/ContextLoader/ContextLoader';
import './index.scss';
// ######## OUT OF THE MAIN MENU ##########
import KDS from './views/Restaurant/Pedidos/KDS/KDS';

// ############ Medio Web Page Components ############
import WebPage from './views/WebPage/Webpage';


// Components for routes
import Login from './views/Restaurant/Login/Login';
import Registration from './views/Companies/Registration/Registration';
import RestaurantSite from './views/Clients/RestaurantSite/RestaurantSite';
import ClientReviews from './views/Clients/ClientReviews/ClientReviews';
import Reservations from './views/Clients/RestaurantSite/components/Reservations/Reservations';
import ClientAuth from './views/Clients/ClientPortal/components/Auth/ClientAuth';
import ClientPortal from './views/Clients/ClientPortal/ClientPortal';
import ResetUserPassword from './views/Restaurant/Login/ResetUserPassword';
import ClientCouponLanding from './views/Clients/Coupons/ClientCouponLanding';
import MercadoPago from './views/Clients/Common/MercadoPago/MercadoPago';
import Tutorials from 'views/Tutorials/Tutorials';
import UserInvitationPage from './views/Restaurant/Configuracion/Usuarios/components/InvitacionesView/components/UserInvitationPage/UserInvitationPage';
import { NotificationsProvider } from './views/Base/components/NavBar/components/HeaderProfile/components/NotificationCenter/NotificationContext';



function NotificationsLayout() {
  return (
    <NotificationsProvider>
      <Outlet />
    </NotificationsProvider>
  );
}

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Handle install prompt
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      setDeferredPrompt(e);

      const installButton = document.getElementById('installButton');
      if (installButton) {
        installButton.style.display = 'block';
      }
    });
  }, []);

  // Run `loadContext` every 6 hours
  useEffect(() => {
    const lastRunTime = localStorage.getItem('lastContextUpdate');
    const now = Date.now();

    if (!lastRunTime || now - parseInt(lastRunTime, 10) >= 6 * 60 * 60 * 1000) {
      loadContext(setLoading, setError)
        .then((response) => {
          if (response) {
            localStorage.setItem('lastContextUpdate', now.toString());
          }
        })
        .catch((err) => {
          console.error('Error updating context:', err);
        });
    }
  }, []);

  // Show loading only for context loading
  if (loading) {
    return (
      <div>
        <LoadingSpinner text="Actualizando contexto..." />
      </div>
    );
  }

  return (
    <>
      <ToastContainer  autoClose={5000} hideProgressBar/>
      <div className="app-container">
        <AuthProvider>
          <Router>
            <Routes>
              {/* Public Routes for Clients */}
              <Route element={<PublicRoute />}>
                <Route path="/" element={<WebPage />} />
                <Route path="/login/:user_id?" element={<Login />} />
                <Route path="/Reservations/:mode/:id" element={<Reservations />} />
                <Route path="/RestaurantSite/:id" element={<RestaurantSite />} />
                <Route path="/web/:id" element={<RestaurantSite />} />
                <Route path="/ClientReviews/:receipt_id" element={<ClientReviews />} />
                <Route path="/Registration/:code" element={<Registration />} />
                <Route path="/ClientAuth/*" element={<ClientAuth />} />
                <Route path="/ClientPortal/*" element={<ClientPortal />} />
                <Route path="/ResetUserPassword/:user_id/:code" element={<ResetUserPassword />} />
                <Route path="/MercadoPago/:preferenceId" element={<MercadoPago />} />
                <Route path="/ClientCouponLanding/:coupon_code" element={<ClientCouponLanding />} />
                <Route path="/UserInvitationPage/:invitation_code" element={<UserInvitationPage />} />
                <Route path="/Tutorials" element={<Tutorials />} />
              </Route>

              {/* Private Routes for Admin/Logged-in Users */}
              <Route element={<PrivateRoute redirectPath="/login" />}>
                <Route element={<NotificationsLayout />}>
                  <Route path="/App/*" element={<Base />} />
                </Route>
                <Route path="/KDS/:workstation_id?" element={<KDS />} />
              </Route>

              {/* Admin Portal - Only for admin users */}
              <Route element={<AdminRoute redirectPath="/login" />}>
                <Route path="/MedioPuntoAdmin/*" element={<AdminPortal />} />
              </Route>
            </Routes>
          </Router>
        </AuthProvider>
      </div>
      {/* <button id="installButton" style={{ display: 'none' }} onClick={handleInstallClick}>
        Install MedioPunto App
      </button> */}
    </>
  );
}

export default App;
